var render = function render(){var _vm=this,_c=_vm._self._c;return _c('alert-modal',{attrs:{"title":_vm.title,"primaryCTAText":_vm.$t('ACTION_CLOSE'),"error":true},on:{"close":_vm.close,"confirm":_vm.close}},[_c('div',{staticClass:"cz2__modal-popup__copy"},[_c('div',{staticClass:"cz2__mb-25",domProps:{"innerHTML":_vm._s(_vm.$t('SAVE_ERROR_BODY'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }